import { permissionsRol as licensesRol } from 'app/policies/roles/licensesRol.access';
import { PATH_LICENSE, PATH_LICENSES, PATH_LICENSE_CREATE } from 'app/router/routesConfigLicenses';

export function licenses(path, user) {
  if (PATH_LICENSE === path) {
    return licensesRol(user).readDetail;
  }

  if (PATH_LICENSES === path) {
    return licensesRol(user).readList;
  }

  if (PATH_LICENSE_CREATE === path) {
    return licensesRol(user).create;
  }

  return true;
}
